import {
  createStyleElement,
  removeStyleElement,
} from '../../../shares/ui/createStyleElement';
import { getSDKConfig } from '../../../shares/lib/getSDKConfig';
import { errorContent } from '../../../shares/ui/errorUI';
import simulateStyles from './simulateStyles.css?inline';

export const simulateElements: Record<string, HTMLElement | null> = {};

export function getSimulateElements() {
  const { simulate } = getSDKConfig();

  const containerId = simulate?.iframeContainerId;
  const container = document.querySelector<HTMLElement>(`${containerId}`);

  if (!container) {
    const message = `Simulate container not found: ${containerId}`;
    throw new Error(message);
  }

  createStyleElement('sm-style', simulateStyles);
  container.classList.add('sm-root');

  const overlay = document.createElement('div');
  overlay.className = 'sm-overlay';
  overlay.hidden = true;

  const main = document.createElement('div');
  main.className = 'sm-main';
  main.hidden = true;

  container.replaceChildren(overlay, main);

  simulateElements.container = container;
  simulateElements.overlay = overlay;
  simulateElements.main = main;

  return { container, overlay, main, showError, showLoader, hideLoader };
}

export function clearSimulateElements() {
  removeStyleElement('sm-style');
  hideLoader();

  if (simulateElements.iframe) {
    simulateElements.iframe.remove();
    delete simulateElements.iframe;
  }

  if (simulateElements.main) {
    simulateElements.main.remove();
    delete simulateElements.main;
  }

  if (simulateElements.container) {
    simulateElements.container.hidden = true;
    simulateElements.container.classList.remove('sm-root');
    delete simulateElements.container;
  }
}

export function showLoader() {
  if (simulateElements.overlay) {
    const loaderHtml = `<span class="sm-loader" />`;
    simulateElements.overlay.hidden = false;
    simulateElements.overlay.innerHTML = loaderHtml;
  }
}

export function hideLoader() {
  if (simulateElements.overlay) {
    simulateElements.overlay.remove();
    delete simulateElements.overlay;
  }
}

export function showError() {
  if (simulateElements.iframe) {
    simulateElements.iframe.hidden = true;
  }

  if (simulateElements.main) {
    simulateElements.main.hidden = true;
  }

  if (simulateElements.overlay) {
    const { title, subTitle, description, buttonTitle } = errorContent();

    const errorHtml = `<div class="sm-error-box">
      <h2 class="sm-error-title">${title}</h2>
      <h4 class="sm-error-sub">${subTitle}</h4>
      <p class="sm-error-dsc">${description}</p>
      <button class="sm-error-btn" onclick="location.reload()">
        ${buttonTitle}
      </button>
    </div>`;

    simulateElements.overlay.hidden = false;
    simulateElements.overlay.innerHTML = errorHtml;
  }
}
